var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('dialog-scroll-lock', {
    attrs: {
      "width": "500",
      "content-class": "fill-height",
      "value": _vm.value
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('input', false);
      }
    }
  }, [_c('v-card', {
    staticClass: "fill-height overflow-auto"
  }, [_c('v-card-title', {
    staticClass: "d-block"
  }, [_c('div', {
    staticClass: "float-right relative ml-3 mr-n3 mt-n1",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_c('btn-search', {
    staticClass: "absolute",
    staticStyle: {
      "right": "100%"
    },
    attrs: {
      "tooltip": "Search guests"
    },
    model: {
      value: _vm.filter,
      callback: function ($$v) {
        _vm.filter = $$v;
      },
      expression: "filter"
    }
  }), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('input', false);
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiClose)
    }
  })], 1)], 1), _vm._v(" Guest list ")]), _vm.totals ? _c('v-card-subtitle', [_vm._v(" Total attending: " + _vm._s(_vm.totals['Attending'])), _vm.form.separate_counts ? [_vm._v(" (" + _vm._s(_vm.totals['Adults']) + " adult" + _vm._s(_vm.totals['Adults'] == 1 ? '' : 's') + ", " + _vm._s(_vm.totals['Children']) + " " + _vm._s(_vm.totals['Children'] == 1 ? 'child' : 'children') + ")")] : _vm._e()], 2) : _vm._e(), _c('v-divider'), !_vm.filtered.length ? _c('div', {
    staticClass: "px-6 py-3 font-italic grey--text",
    staticStyle: {
      "font-size": "12px",
      "line-height": "16px"
    }
  }, [_vm._v("No guests found")]) : _vm._e(), _vm._l(_vm.filtered, function (row, i) {
    return _c('div', {
      staticClass: "px-6 py-3"
    }, [_c('div', {
      staticClass: "to",
      domProps: {
        "textContent": _vm._s(row.name)
      }
    }), _vm._l(_vm.fields, function (key) {
      return _c('div', {
        staticClass: "guest-data"
      }, [_c('span', {
        staticClass: "font-italic grey--text mr-3"
      }, [_vm._v(_vm._s(key))]), key == 'Attendees' ? [!_vm.getFieldValue(row, key).length ? [_vm._v("–")] : _vm._l(_vm.getFieldValue(row, key), function (_ref) {
        var name = _ref.name,
          type = _ref.type;
        return _c('div', {
          staticClass: "ml-4"
        }, [_vm.form.separate_counts ? _c('v-icon', {
          staticStyle: {
            "width": "16px",
            "height": "16px",
            "vertical-align": "text-top"
          },
          domProps: {
            "innerHTML": _vm._s(type == 'child' ? _vm.iconPathChild : _vm.mdiHumanMale)
          }
        }) : _vm._e(), _vm._v(_vm._s(name) + " ")], 1);
      })] : [_vm._v(_vm._s(_vm.getFieldValue(row, key) || (_vm.getFieldValue(row, key) === 0 ? 0 : '–')))]], 2);
    })], 2);
  })], 2)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }